<template>
  <v-container>
    <v-btn fixed dark fab bottom right color="pink" @click="createNew">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-data-table :items="counters" :headers="headers" :loading="isBusy"
                  @click:row="editSelected" disable-pagination hide-default-footer
                  fixed-header disable-sort class="row-pointer">
      <template v-slot:item.type="{ item }">
        <span>{{ typeToStr(item.type) }}</span>
      </template>
      <template v-slot:item.isActive="{ item }">
        <v-icon>{{ item.isActive === true ? "mdi-checkbox-marked-outline" : "mdi-checkbox-blank-outline" }}</v-icon>
      </template>
      <template v-slot:item.index="{item}">
        <v-btn v-if="item.isActive && !isFirstItem(item)" class="mr-1" fab top small @click.stop="moveUp(item)">
          <v-icon>mdi-arrow-up-bold</v-icon>
        </v-btn>
        <span v-else class="v-btn v-btn--round v-btn--fab v-size--small mr-1" />
        <v-btn v-if="item.isActive && !isLastItem(item)" fab top small @click.stop="moveDown(item)">
          <v-icon>mdi-arrow-down-bold</v-icon>
        </v-btn>
        <span v-else class="v-btn v-btn--round v-btn--fab v-size--small" />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>

const counterType = {
  "WATER_HOT": "Горячая вода",
  "WATER_COLD": "Холодная вода",
  "ELECTRO_1": "Электричество (1 тариф)",
  "ELECTRO_2": "Электричество (2 тарифа)",
  "ELECTRO_3": "Электричество (3 тарифа)",
}

export default {
  name: 'Counters',
  data() {
    return {
      isBusy: false,
      headers: [
        {value: 'isActive', text: 'Активный', align: 'center'},
        {value: 'type', text: 'Тип'},
        {value: 'title', text: 'Местонахождения'},
        {value: 'number', text: 'Номер'},
        {value: 'index', text: 'Порядок'}
      ],
      counters: []
    }
  },
  mounted() {
    this.isBusy = true
    this.$http("/counter")
        .then(resp => this.counters = resp.data)
        .finally(() => this.isBusy = false)
  },
  methods: {
    typeToStr: function (type) {
      return counterType[type] ?? type
    },
    createNew: function () {
      this.$router.push({name: 'CounterEdit', params: {counterId: null}})
    },
    editSelected: function (item) {
      this.$router.push({name: 'CounterEdit', params: {counterId: item.id}})
    },
    moveUp: function (item) {
      let index = this.counters.findIndex(c => c.id === item.id)
      let tmp = this.counters[index - 1]
      this.$set(this.counters, index - 1, this.counters[index])
      this.$set(this.counters, index, tmp)
      this.$http.get(`/counter/${this.counters[index - 1].id}/swap/${this.counters[index].id}`)
    },
    moveDown: function (item) {
      let index = this.counters.findIndex(c => c.id === item.id)
      let tmp = this.counters[index + 1]
      this.$set(this.counters, index + 1, this.counters[index])
      this.$set(this.counters, index, tmp)
      this.$http.get(`/counter/${this.counters[index + 1].id}/swap/${this.counters[index].id}`)
    },
    isFirstItem: function (item) {
      return this.counters.findIndex(c => c.id === item.id) === 0
    },
    isLastItem: function (item) {
      let list = this.counters.filter(c => c.isActive)
      return list.findIndex(c => c.id === item.id) === (list.length - 1)
    },
  }
}

</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}

.btn-space {
  align-items: center;
  display: inline-flex;
  vertical-align: middle;
}
</style>